// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"FF-z","smallCardRow":"GF-z","largeCardRow":"HF-z","productSearchRow":"IF-z","curatedRow":"JF-z"};